import script from "./MenuItemWineSize.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemWineSize.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemWineSize.vue?vue&type=style&index=0&id=53323b18&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53323b18"]])

export default __exports__